import { render, staticRenderFns } from "./SearchDictData.vue?vue&type=template&id=08b912a0&scoped=true"
import script from "./SearchDictData.vue?vue&type=script&lang=js"
export * from "./SearchDictData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b912a0",
  null
  
)

export default component.exports